import { GlobalApplicationState } from "globalApplicationState";

export const TenantTagGroupsSelector = (state: GlobalApplicationState) => {
    return state?.settings?.tenantSettings?.tagGroups;
};
